import {FormattedMessage} from "react-intl";
import {TYPE_FIMLAB} from "../../../../../../../definitions/TimelineItems";
import {OTLink} from "../../../../../../../components/tag/OTLink";
import OTIcon from "../../../../../../../components/tag/OTIcon";
import React from "react";

let { id: module_id } = module;
export const TimelineFrameContentFimlabAppointment = () => {

    return (
        <p>
            <FormattedMessage
                id={`${module_id}.${TYPE_FIMLAB}.appointment`}
                values={{
                    br: <br/>,
                    a: (chunks) => <OTLink
                        target="_blank"
                        onClick={(e) => e.stopPropagation()}
                        link={"https://fimlab.fi/ajanvaraus"}
                        isExternal={true}
                        className="card-link"
                    >{chunks}</OTLink>
                }}
            />
        </p>
    );
}